import { Ref } from "@tblabs/truffle";


export class Router
{
    public GoToAgentsPage(): void
    {
        this.hash.value = `admin/agents`;
    }
    
    public GoToExpenses(): void
    {
        this.hash.value = `admin/expanses`;
    }

    public GoToOrderCreate(orderId?: string): void
    {
        this.hash.value = `order-creation${orderId ? `/${orderId}` : ""}`;
    }
    
    public GoToAgentTasks(agentId: string): void
    {
        this.hash.value = `agent/${agentId}/tasks`;
    }

    public GoToOrderEdit(orderId: string): void
    {
        this.hash.value = `admin/order/${orderId}/edit`;
    }

    public GoToOrderRawEdit(orderId: string): void
    {
        this.hash.value = `admin/order/${orderId}/raw`;
    }

    public GoToLogin(): void
    {
        this.hash.value = `admin/login`;
    }
    
    public GoToCustomerView(orderId: string): void
    {
        this.hash.value = `order/${orderId}`;
    }

    constructor(private hash: Ref<string>)
    { }

    public GoToOrdersList(): void
    {
        this.hash.value = `admin/orders`;
    }

    public GoToOrderView(orderId: string): void
    {
        this.hash.value = `admin/order/${orderId}/view`;
    }

    // public GoBack()
    // {
    //     /*
    //     TO NIE DZIAŁA:

    //     history.back(); // cofa adres ale nie przeładowuje strony
    //     location.reload(); // to też nie przeładowuje
    //     */
    //     this.history.pop();
    //     this.hash.value = this.history.pop() || "admin/orders";
    // }
}
